/* Ralhum Sports personality layer: gear finder, reveal on scroll, count-up numbers.
   Everything here is optional. With JavaScript off, the page still shows all content and every link works. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Gear finder: sport + budget -> collection URL with price filter ---------- */
  function money(n) { return 'Rs ' + Number(n).toLocaleString('en-US'); }

  function initFinder(root) {
    var sports = [].slice.call(root.querySelectorAll('[data-rs-sport]'));
    var budgetStep = root.querySelector('[data-rs-budget]');
    var budgets = [].slice.call(root.querySelectorAll('[data-rs-band]'));
    var go = root.querySelector('[data-rs-go]');
    var goLink = root.querySelector('[data-rs-golink]');
    var sum = root.querySelector('[data-rs-sum]');
    if (!sports.length || !budgetStep || !go || !goLink) return;

    var state = { sport: null, band: budgets[0] || null };

    function bandLabel(b) {
      if (!b) return 'any budget';
      var min = b.getAttribute('data-min'), max = b.getAttribute('data-max');
      if (!min && !max) return 'any budget';
      if (min && !max) return money(min) + ' and above';
      if (!min && max) return 'under ' + money(max);
      return money(min) + ' to ' + Number(max).toLocaleString('en-US');
    }

    function update() {
      if (!state.sport) return;
      var url = state.sport.getAttribute('href').split('?')[0];
      var q = [];
      var b = state.band;
      if (b) {
        var min = b.getAttribute('data-min'), max = b.getAttribute('data-max');
        if (min) q.push('filter.v.price.gte=' + encodeURIComponent(min));
        if (max) q.push('filter.v.price.lte=' + encodeURIComponent(max));
      }
      goLink.setAttribute('href', url + (q.length ? '?' + q.join('&') : ''));
      var name = state.sport.getAttribute('data-label') || state.sport.textContent.trim();
      if (sum) sum.textContent = name + ' gear, ' + bandLabel(b);
    }

    function press(list, on) {
      list.forEach(function (el) { el.setAttribute('aria-pressed', el === on ? 'true' : 'false'); });
    }

    sports.forEach(function (a) {
      a.setAttribute('role', 'button');
      a.setAttribute('aria-pressed', 'false');
      a.addEventListener('click', function (e) {
        e.preventDefault();
        state.sport = a;
        press(sports, a);
        budgetStep.hidden = false;
        go.hidden = false;
        if (state.band) press(budgets, state.band);
        update();
      });
      a.addEventListener('keydown', function (e) {
        if (e.key === ' ') { e.preventDefault(); a.click(); }
      });
    });

    budgets.forEach(function (b) {
      b.setAttribute('aria-pressed', b === state.band ? 'true' : 'false');
      b.addEventListener('click', function () {
        state.band = b;
        press(budgets, b);
        update();
      });
    });
  }

  /* ---------- Count-up for the story numbers ---------- */
  function countUp(el) {
    var raw = el.textContent.trim();
    var m = raw.match(/^(\D*)(\d[\d,]*)(.*)$/);
    if (!m) return;
    var target = parseInt(m[2].replace(/,/g, ''), 10);
    if (!isFinite(target) || target < 2) return;
    var start = null, dur = 1100;
    el.setAttribute('aria-label', raw);
    function frame(t) {
      if (start === null) start = t;
      var p = Math.min(1, (t - start) / dur);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = m[1] + Math.round(target * eased).toLocaleString('en-US') + m[3];
      if (p < 1) requestAnimationFrame(frame); else el.textContent = raw;
    }
    el.textContent = m[1] + '0' + m[3];
    requestAnimationFrame(frame);
  }

  function ready() {
    [].forEach.call(document.querySelectorAll('[data-rs-finder]'), initFinder);

    if (reduce || !('IntersectionObserver' in window)) return;

    var selectors = [
      '.rs-head', '.rs-row__head', '.rs-tiles > li', '.rs-trustbar__item', '.rs-trade__card',
      '.rs-story__stat', '.rs-brands > li', '.rs-help__card', '.rs-finder', '.rs-dealerstrip__cta'
    ];
    var items = [].slice.call(document.querySelectorAll(selectors.join(',')));
    if (!items.length) return;

    document.documentElement.classList.add('rs-motion');
    items.forEach(function (el) {
      var sibs = el.parentElement ? [].slice.call(el.parentElement.children) : [el];
      var i = Math.min(sibs.indexOf(el), 8);
      el.style.setProperty('--rs-i', i < 0 ? 0 : i);
      el.classList.add('rs-reveal');
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        el.classList.add('is-in');
        io.unobserve(el);
        if (el.classList.contains('rs-story__stat')) {
          var num = el.querySelector('.rs-story__num');
          if (num) countUp(num);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    items.forEach(function (el) { io.observe(el); });

    /* Safety net: if anything never fires, show it anyway. */
    setTimeout(function () {
      items.forEach(function (el) { el.classList.add('is-in'); });
    }, 8000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
})();
